// extracted by mini-css-extract-plugin
module.exports = {"pages":"Pages_pages__kkp_y","htmlPage":"Pages_htmlPage__2g6Rj","bodyPage":"Pages_bodyPage__PQfn4","pageWrapper":"Pages_pageWrapper__t-owh"};